import { useEffect, useRef } from 'react';
import useFacebookPixel from '../utils/useFacebookPixel';
import { getUserData, generateEventId } from '../utils/metaHelpers';

// Flag global para evitar duplicados (persiste entre renders y remontajes)
let lastSentPath = '';
let isSending = false;

/**
 * Componente que envía eventos PageView a Meta (Pixel + CAPI)
 * Se ejecuta automáticamente cuando cambia la ruta en Gatsby.
 * 
 * DEDUPLICACIÓN: Genera UN SOLO event_id y lo envía tanto al Pixel (fbq)
 * como a CAPI para que Meta pueda deduplicar correctamente.
 */
const MetaPageView = () => {
  const { trackPageView } = useFacebookPixel();
  const timerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const currentPath = window.location.pathname + window.location.search;
    
    // Solo enviar si la ruta cambió y no hay un envío en curso
    if (currentPath !== lastSentPath && !isSending) {
      // Limpiar timer anterior si existe
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      
      lastSentPath = currentPath;
      isSending = true;
      
      // Pequeño delay para asegurar que la página está completamente cargada
      timerRef.current = setTimeout(() => {
        const user = getUserData();
        // Generar UN SOLO event_id para Pixel y CAPI
        const eventId = generateEventId('pageview');
        
        trackPageView({
          event_source_url: window.location.href,
          event_id: eventId,
          user: user,
        });
        isSending = false;
        timerRef.current = null;
      }, 100);
    }

    // Cleanup: limpiar timer si el componente se desmonta
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
        isSending = false;
      }
    };
  }); // Sin dependencias - se ejecuta en cada render pero solo actúa si cambió la ruta

  return null;
};

export default MetaPageView;